import { loggedInUser } from 'hooks/use-logged-in-user';
import { useTaskService } from 'hooks/services/use-task-service';
import { useQuery } from '@tanstack/react-query';
import { ITaskType } from 'types';

interface TaskTypesCache {
  taskTypes: ITaskType[];
  isTaskTypesLoading: boolean;
  hasTaskTypes: boolean;
}

export const useTaskTypesCache = (): TaskTypesCache => {
  const taskService = useTaskService();
  const { isLoggedIn } = loggedInUser.useController();

  const query = useQuery({
    queryKey: ['taskTypes'],
    queryFn: () => taskService.getTaskTypes(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isTaskTypesLoading, data: taskTypes = [] } = query;

  return {
    isTaskTypesLoading,
    taskTypes,
    hasTaskTypes: taskTypes.length > 0
  };
};
